import { render, staticRenderFns } from "./Postscripts.vue?vue&type=template&id=93c644e2"
import script from "./Postscripts.vue?vue&type=script&lang=ts"
export * from "./Postscripts.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports